import { deviceType } from '../utils';

const amplitudeTrackEvent = (eventName, props = {}) => fetch('https://paystack-ats.glitch.me/a-track', {
	method: 'POST',
	headers: {
		'Content-Type': 'application/json',
	},
	body: JSON.stringify({
		event: eventName,
		props: {
			'Device Type': deviceType(),
			Referrer: document.referrer,
			...props,
		},
	}),
});

export default amplitudeTrackEvent;
